import React from 'react'
import styled from 'styled-components'
import { Image, Wrapper, H, P, Grid } from '@farewill/ui'
import { screenMin } from '@farewill/ui/helpers/responsive'
import { GTR, COLOR, BORDER } from '@farewill/ui/tokens'

import AspectRatioWrapper from 'components/AspectRatioWrapper'
import PreventOrphan from 'components/PreventOrphan'

import SliceExpertSupport from 'views/cremation/components/YourWay/ExpertSupport'

import data from './data'

const StyledStep = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  ${screenMin.m`
    flex-direction: row;
  `}

  ${screenMin.l`
    flex-direction: column;
  `}
`

const StyledStepImageWrapper = styled.div`
  flex: 1 0 250px;
  margin: 0 ${GTR.M} 0 0;
`

const StyledStepTextWrapper = styled.div`
  flex: 1 1 auto;
`

const StyledStepImageInner = styled.div`
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
`

const StyledStepImage = styled(Image)`
  object-fit: contain;
`

const StyledStepTitle = styled(H)`
  margin-bottom: ${GTR.XS};

  ${screenMin.m`
    margin-bottom: ${GTR.S};
  `};
`
const StyledWrapper = styled(Wrapper)`
  padding-bottom: 0;

  ${screenMin.m`
    text-align: center
  `}
`

const StyledExpertSupportWrapper = styled(Wrapper)`
  box-shadow: ${BORDER.SHADOW.M};
`

const YourWay = (): React.ReactElement => (
  <Wrapper background={COLOR.ACCENT.PRIMARY_10}>
    <StyledWrapper
      paddingBottom={0}
      maxWidth={780}
      margin={[0, 'auto']}
      container
    >
      <H size="L" tag="h2" decorative>
        {data.title}
        <br />
        {data.title2}
      </H>
      <P>{data.subtitle}</P>
    </StyledWrapper>

    <Wrapper container>
      <Grid gapFromM="XL">
        {data.steps.map((step) => (
          <Grid.Item spanFromL={4} key={step.title}>
            <StyledStep>
              <StyledStepImageWrapper>
                <StyledStepImageInner>
                  <AspectRatioWrapper ratio={1 / 1}>
                    <StyledStepImage
                      path={`illustrations/${step.illustration}`}
                      width={250}
                      stretch
                    />
                  </AspectRatioWrapper>
                </StyledStepImageInner>
              </StyledStepImageWrapper>
              <StyledStepTextWrapper>
                <StyledStepTitle tag="h3" size="S">
                  <PreventOrphan>{step.title}</PreventOrphan>
                </StyledStepTitle>
                <P>
                  <PreventOrphan>{step.description}</PreventOrphan>
                </P>
              </StyledStepTextWrapper>
            </StyledStep>
          </Grid.Item>
        ))}
      </Grid>

      <StyledExpertSupportWrapper
        margin={['XL', 0]}
        marginFromM={['XXL', 0]}
        borderRadius="S"
        background={COLOR.WHITE}
      >
        <SliceExpertSupport />
      </StyledExpertSupportWrapper>
    </Wrapper>
  </Wrapper>
)

export default YourWay
